import { render, staticRenderFns } from "./ManageSupplierMasterIcon.vue?vue&type=template&id=45f4c21c"
import script from "./ManageSupplierMasterIcon.vue?vue&type=script&lang=js"
export * from "./ManageSupplierMasterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports